import { render, staticRenderFns } from "./ParamAreaEmpresa.vue?vue&type=template&id=a48dc820"
import script from "./ParamAreaEmpresa.vue?vue&type=script&lang=js"
export * from "./ParamAreaEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports